import { c as _c } from "react/compiler-runtime";
import { useDebounce } from 'react-use';
import { useEffect, useState } from 'react';
import { useInstallmentsCalculator } from '@/api/skippay/publicInstallmentsCalculator';
export type Amount = {
  amount: number;
  currency: string;
};
export type InstallmentsPlan = {
  installmentValue: Amount;
  installmentsCount: number;
  interestRate: string;
  dueDate: string;
  principal: Amount;
  totalClaim: Amount;
  totalInterestValue: Amount;
  rpsn: string;
};
export type InstallmentCalculatorData = {
  installments: {
    allowed: number[];
    min: number;
    max: number;
  };
  selectedPlan?: InstallmentsPlan;
  isSelectedPlanReady: boolean;
  isLoading: boolean;
  rpsn?: string;
};
export function useCalculator(principal, paymentsCount) {
  const $ = _c(32);
  const [debouncedPrincipal, setDebouncedPrincipal] = useState(principal);
  let t0;
  if ($[0] !== principal) {
    t0 = () => setDebouncedPrincipal(principal);
    $[0] = principal;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== principal) {
    t1 = [principal];
    $[2] = principal;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  useDebounce(t0, 300, t1);
  let t2;
  if ($[4] !== debouncedPrincipal) {
    t2 = debouncedPrincipal?.toString() || "0";
    $[4] = debouncedPrincipal;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const principalStr = t2;
  let t3;
  if ($[6] !== principalStr) {
    t3 = {
      principal: principalStr
    };
    $[6] = principalStr;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = !!debouncedPrincipal;
  let t5;
  if ($[8] !== t4) {
    t5 = {
      enabled: t4,
      staleTime: 300000
    };
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const {
    data,
    isLoading
  } = useInstallmentsCalculator(t3, t5);
  let t6;
  if ($[10] !== data?.allowedInstallmentsCounts) {
    t6 = data?.allowedInstallmentsCounts ?? [];
    $[10] = data?.allowedInstallmentsCounts;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const allowedInstallmentsCounts = t6;
  let t7;
  if ($[12] !== data?.installmentsPlans) {
    t7 = data?.installmentsPlans ?? [];
    $[12] = data?.installmentsPlans;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== paymentsCount || $[15] !== t7) {
    let t9;
    if ($[17] !== paymentsCount) {
      t9 = plan => plan.installmentsCount === paymentsCount;
      $[17] = paymentsCount;
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    t8 = t7.find(t9);
    $[14] = paymentsCount;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const currentPlan = t8;
  const [displayedPlan, setDisplayedPlan] = useState(undefined);
  let t10;
  let t9;
  if ($[19] !== currentPlan || $[20] !== isLoading) {
    t9 = () => {
      if (!isLoading && currentPlan) {
        setDisplayedPlan(currentPlan);
      }
    };
    t10 = [isLoading, currentPlan];
    $[19] = currentPlan;
    $[20] = isLoading;
    $[21] = t10;
    $[22] = t9;
  } else {
    t10 = $[21];
    t9 = $[22];
  }
  useEffect(t9, t10);
  const t11 = allowedInstallmentsCounts[0] ?? 0;
  const t12 = allowedInstallmentsCounts[allowedInstallmentsCounts.length - 1] ?? 0;
  let t13;
  if ($[23] !== allowedInstallmentsCounts || $[24] !== t11 || $[25] !== t12) {
    t13 = {
      allowed: allowedInstallmentsCounts,
      min: t11,
      max: t12
    };
    $[23] = allowedInstallmentsCounts;
    $[24] = t11;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  const installments = t13;
  const t14 = !isLoading && !!displayedPlan;
  let t15;
  if ($[27] !== displayedPlan || $[28] !== installments || $[29] !== isLoading || $[30] !== t14) {
    t15 = {
      installments,
      selectedPlan: displayedPlan,
      isSelectedPlanReady: t14,
      isLoading
    };
    $[27] = displayedPlan;
    $[28] = installments;
    $[29] = isLoading;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  return t15;
}